import React from 'react';
import moment from 'moment';
import HttpClient from 'services/HttpClient';
import CollapseContainer from '../components/Base';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
const TRACKER = '/api/v1/trackers';

@withRouter
export default class extends React.Component {

  state = {revisions: {}};

  componentWillMount(){
    new HttpClient().get(TRACKER).then(data => {
      if(data.body.data && !_.isEmpty(data.body.data.revisions)) {
        const { cpd_points, revisions } = data.body.data;

        this.setState({cpd_points, revisions});
      }
      else  {
        this.props.history.push('emptytracker');
      }
    })
  }

  render(){
    // const date = this.state.total_period ? this.state.total_period.split(' - ') : ['', ''];
    const startAt = moment().format('YY');// moment(new Date(date[0])).format('YY');
    const endAt = moment().add(1, 'y').format('YY'); // moment(date[1]).add(1, 'y').format('YY');

    return (
      <div className="tracker">
        <div className="container-fluid tracker-container">
          {/* <div className="tracker-head">
            <div className="tracker-period tracker-head-holder">
              <div className="tracker-head-caption">
                {`CPD Year: May ${startAt} - Apr ${endAt}`}
              </div>
            </div>
            <div className="tracker-activity tracker-head-holder">
              <div className="tracker-head-caption align-right">Total activity:</div>
              <div className="tracker-head-info">
                <span>CPD Points: {this.state.cpd_points} Ext</span>
              </div>
            </div>
          </div> */}
          {/* {_.keys(this.state.revisions).map( (key) => */}
          {this.state.revisions.length > 0 &&
            <div className="tracker-content">
              <div className="tracker-content-holder">
                {/* <h3 className="tracker-content-caption">{this.state.revisions[key].course_title}</h3> */}
                <CollapseContainer elements={this.state.revisions}/>
              </div>
            </div>
          }
          {/* )

          } */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/personaTrecker/containers/PersonalTracker.js